import { ChevronLeft, ChevronRight } from 'lucide-react';

type LiksDocumentPreviewHeaderProps = {
  hasMultipleItems: boolean;
  activeIndex: number;
  itemCount: number;
  canGoPrevious: boolean;
  canGoNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
};

export function LiksDocumentPreviewHeader({
  hasMultipleItems,
  activeIndex,
  itemCount,
  canGoPrevious,
  canGoNext,
  onPrevious,
  onNext,
}: LiksDocumentPreviewHeaderProps) {
  if (!hasMultipleItems) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="liks-document-preview__nav"
        aria-label="Previous document"
        disabled={!canGoPrevious}
        onClick={onPrevious}
      >
        <ChevronLeft
          className="liks-document-preview__nav-icon"
          strokeWidth={2}
          aria-hidden
        />
      </button>
      <span className="liks-document-preview__position" aria-live="polite">
        {activeIndex + 1} / {itemCount}
      </span>
      <button
        type="button"
        className="liks-document-preview__nav"
        aria-label="Next document"
        disabled={!canGoNext}
        onClick={onNext}
      >
        <ChevronRight
          className="liks-document-preview__nav-icon"
          strokeWidth={2}
          aria-hidden
        />
      </button>
    </>
  );
}
